import React from "react";
import { ImageAsset, SVGAsset } from "res";
import "./styles.css";

/**
 * @function CheckPictureWidget
 * @param {STRING} text - Allows us to add text to label the BackCheckPictureWidget and FrontCheckPictureWidget
 * @param {React.Component} checkWorkflow - Allows us to insert the BackCheckPictureWidget and FrontCheckPictureWidget
 * @return {React.Component}
 * @exported true
 * @description The CheckPictureWidget is the base component for the BackCheckPictureWidget and FrontCheckPictureWidget
 * @example
 * <CheckPictureWidget text="Front of Check" checkWorkflow="<><FrontCheckPictureWidget /></>" />
 */

export default function CheckPictureWidget(props) {
  const text = props.text?? "";
  const checkWorkflow = props.checkWorkflow;
  const textClassName = props.textClassName ? { className: props.textClassName } : { className: "text-center" };

  return(
    
      <div className="check-picture-widget flex-container flex-horizontal flex-width">
        <div className="check-picture-widget-container flex-width">
          <p { ...textClassName }>{text}</p>
          {checkWorkflow}
        </div>
      </div>
  );
}

/**
 * @function FrontCheckPictureWidget
 * @param {STRING} image - Allows us to pass either an SVG or Image object
 * @param {FUNCTION} onClick - Allows us to set an event handler for when clicked. 
 * @return {React.Component}
 * @exported true
 * @description The FrontCheckPictureWidget shows the front of the check camera icon and front of check image. 
 * @example
 * <FrontCheckPictureWidget image={<><SVGAsset id="CameraIcon" /></>} onClick={onClick} />
 */

export function FrontCheckPictureWidget(props) {
  const image = props.image ?? <></>;
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  
  return(
      <div className="front-check-picture-widget check-picture-background flex-container all-center" onClick={ props.onClick } { ...dataPoint }>
        {image}
      </div>
  );
}

/**
 * @function BackCheckPictureWidget
 * @param {STRING} image - Allows us to pass either an SVG or Image object
 * @param {FUNCTION} onClick - Allows us to set an event handler for when clicked. 
 * @return {React.Component}
 * @exported true
 * @description The BackCheckPictureWidget shows the front of the check camera icon and front of check image. 
 * @example
 * <BackCheckPictureWidget image={<><SVGAsset id="CameraIcon" /></>} onClick={onClick} />
 */

export function BackCheckPictureWidget(props) {
  const image = props.image ?? <></>;
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  return(
      <div className="back-check-picture-widget check-picture-background flex-container all-center" onClick={ props.onClick } { ...dataPoint }>
        {image}
      </div>
  );
}